<div class="mtb-20">
  <div class="font-24 flex gap-10 border-bottom border-gray-600 mb-20 pb-10">
    <div class="icon-gray">
      <i class="fa-solid fa-cart-shopping"></i>
    </div>
    <div>
      Roles Added to Request Cart:
    </div>
    <div class="bold">
      <strong>{{rolesOnCart.length}}</strong>
    </div>
  </div>
  @if (rolesOnCart.length > 0) {
    <div>
      <!-- This is the cart container -->
      <div class="card fluid">
        <div class="card__content border-bottom border-gray-600">
          <div class="width-full">
            <ul class="cart-items">
              <!-- This is cart item -->
              @for (selectedRole of rolesOnCart; track selectedRole) {
                <li>
                  <div class="flex width-full basis-70">
                    <div class="flex justify-start pt-10">
                      <a href="#" (click)="toggleCartInfo()">{{selectedRole.applicationRoleName}}</a>
                    </div>
                    <div class="flex justify-end basis-30 delete-cart-item">
                      <button (click)="onRemoveRole(selectedRole)" id="" title="Delete Email"
                        style="padding: 0 7px;"
                        class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
                        <div class="icon trash icon-red font-20">
                          <i class="fas fa-trash"></i>
                        </div>
                      </button>
                    </div>
                  </div>
                  @if (showConfirmation && roleToDelete == selectedRole) {
                    <ng-container class="fade">
                      <div class="mtb-10 fade">
                        <app-delete-confirmation (doDelete)="confirm()"
                        (doCancel)="cancel()"></app-delete-confirmation>
                      </div>
                    </ng-container>
                  }
                  @if (showCartInfo) {
                    <div class="mtb-10 fade">
                      <div
                        class="flex gap-30 to-block width-full border-bottom border-gray-600 mb-20 pb-10">
                        <div class="basis-50">
                          <div>
                            <b>System</b>
                          </div>
                          <div class="mt-10">
                            <ul class="cart-info">
                              <li>
                                One Funding Application
                              </li>
                              <li>
                                One Funding Application
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="basis-50">
                          <div>
                            <b>Permissions Granted</b>
                          </div>
                          <!-- this is a responsibility for selected role -->
                          <div class="mt-10">
                            <div>
                              <b>CCIP Authorized Representative</b>
                            </div>
                            <ul class="cart-info">
                              <li>
                                Authorized Representative approval or rejection to a Grant
                                Application and
                                FER
                              </li>
                              <li>
                                Edit a Grant Application, PCR, FER, or associated district
                                comment log
                              </li>
                              <li>
                                View unapproved Grant Applications, PCRs, and FERs, and
                                associated district
                                comment
                                logs
                              </li>
                            </ul>
                          </div>
                          <!-- End this is a responsibility for selected role -->
                        </div>
                      </div>
                      <div>
                        <div class="inline-text-field-container mb-20">
                          <div class="mb-5">Reason for requesting the role.</div>
                          <div class="text-area-container">
                            <label for="address2"
                            class="ds-floating-label text-area">Reason</label>
                            <textarea class="textarea" name="subject" rows="3"></textarea>
                          </div>
                        </div>
                        <div class="inline-text-field-container even-cols flex-row gap-20">
                          <div class="ds-text-field gray">
                            <input class="ds-text-field__input" id="address" type="text"
                              name="address" autocomplete="off" value="" required="">
                              <label for="address" class="ds-floating-label ">*Effective Date</label>
                              <div class="field-line-ripple blue"></div>
                              <span class="help display-none"></span>
                              <span class="error display-none"></span>
                            </div>
                            <div></div>
                            <div></div>
                          </div>
                        </div>
                        <div class="flex gap-20 justify-end mt-10">
                          <button (click)="toggleCartInfo()" id=""
                            class="secondary border-red rounded-4 hover-red hover-font-white flex-row-reverse">
                            <div class="btn-txt font-red bold">Cancel</div>
                          </button>
                          <button class="rounded-4 hover-blue-800 black">
                            <div class="btn-txt font-white bold">Update Comment</div>
                          </button>
                        </div>
                      </div>
                    }
                  </li>
                }
                <!--End This is cart item -->
              </ul>
            </div>
          </div>
        </div>
        <!--End This is the cart container -->
      </div>
    }
    @if (rolesOnCart.length == 0) {
      <div class="m-auto p-40 font-45 bold font-gray-700 text-center">
        The Request Cart Is Empty
      </div>
    }
  </div>
  <!--End this is the cart section -->